import Actions from '../actions';
import translations from '../../translations/app-translations.json';
import { refreshOrderNotifyEP } from '../errors/processors/refresh-order';

const refreshOrderProcess = (dispatch, locale, toastr,
    configs = {
        successNotify: '',
        addingProductToCartAction: true,
    }) => dispatch(Actions.refreshOrder(locale))
    .then(() => {
        if (configs.successNotify && configs.successNotify.length > 0) {
            toastr.success(translations[locale].well, configs.successNotify);
        }
    })
    .catch((error) => {
        refreshOrderNotifyEP(error, locale, toastr);
    })
    .finally(() => {
        if (configs.addingProductToCartAction) {
            dispatch(Actions.addingProductToCartFix(false));
        }
    });

export default refreshOrderProcess;



/** WEBPACK FOOTER **
 ** ./src/services/refresh-order-process.js
 **/